import { pushLine, type TimelineVertex } from "./vertex-primitives";

export interface WorldView {
  originX: number;
  originY: number;
  zoom: number;
  canvasW: number;
  canvasH: number;
  worldW: number;
  worldH: number;
}

export function worldViewFromTransform(
  panX: number,
  panY: number,
  zoom: number,
  canvasW: number,
  canvasH: number,
  worldW: number,
  worldH: number,
): WorldView {
  return {
    originX: -panX / zoom,
    originY: -panY / zoom,
    zoom,
    canvasW,
    canvasH,
    worldW,
    worldH,
  };
}

export function pushWorldLine(
  verts: TimelineVertex[],
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  view: WorldView,
  r: number,
  g: number,
  b: number,
  a: number,
  /** Half-thickness in world CSS px; scales on screen with zoom. */
  width = 1,
): void {
  const viewRight = view.originX + view.canvasW / view.zoom;
  const viewBottom = view.originY + view.canvasH / view.zoom;
  if (!segmentIntersectsRect(x1, y1, x2, y2, view.originX, view.originY, viewRight, viewBottom)) {
    return;
  }
  const cx1 = (x1 - view.originX) * view.zoom;
  const cy1 = (y1 - view.originY) * view.zoom;
  const cx2 = (x2 - view.originX) * view.zoom;
  const cy2 = (y2 - view.originY) * view.zoom;
  const screenHalfThickness = width * view.zoom;
  pushLine(verts, cx1, cy1, cx2, cy2, r, g, b, a, screenHalfThickness);
}

function segmentIntersectsRect(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  left: number,
  top: number,
  right: number,
  bottom: number,
): boolean {
  const minX = Math.min(x1, x2);
  const maxX = Math.max(x1, x2);
  const minY = Math.min(y1, y2);
  const maxY = Math.max(y1, y2);
  return maxX >= left && minX <= right && maxY >= top && minY <= bottom;
}
